/**
 * 可中断的 sleep：signal abort 时立即 reject（AbortError），不再空等计时结束。
 * 用于轮询循环（craft-mode 流水线状态、pollGenerationStatus 等），
 * 保证组件卸载 / 新一轮触发时上一轮立即停下。
 */
export function abortableSleep(ms: number, signal: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal.aborted) {
      reject(new DOMException("轮询已取消", "AbortError"));
      return;
    }
    const timer = setTimeout(() => {
      signal.removeEventListener("abort", onAbort);
      resolve();
    }, ms);
    const onAbort = () => {
      clearTimeout(timer);
      reject(new DOMException("轮询已取消", "AbortError"));
    };
    signal.addEventListener("abort", onAbort, { once: true });
  });
}

/** signal 已 abort 时抛 AbortError（轮询每轮开头调用，确保卸载后不再发请求）。 */
export function throwIfAborted(signal: AbortSignal | undefined): void {
  if (signal?.aborted) {
    throw new DOMException("轮询已取消", "AbortError");
  }
}
